import { Col, Form, Row, Select } from "antd";
import type React from "react";

const { Option } = Select;

interface MemberBlockStatusFilterProps {
	className?: string;
}

export const MemberBlockStatusFilter: React.FC<
	MemberBlockStatusFilterProps
> = ({ className = "mb-4" }) => {
	return (
		<Row gutter={[16, 16]} justify="start">
			<Col xs={{ span: 24 }}>
				<Form.Item name="isFriends" className={className}>
					<Select
						placeholder="ブロックユーザーのみ／ブロックユーザーを含まない"
						allowClear
					>
						<Option value={1}>ブロックユーザーを含まない</Option>
						<Option value={0}>ブロックユーザーのみ</Option>
					</Select>
				</Form.Item>
			</Col>
		</Row>
	);
};
